import React from "react";
import { Grid, Card, Header, Label, Loader } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_MY_USER } from "../GraphQL";

const PostUpgradePage = () => {
  const { loading, error } = useQuery(GET_MY_USER, {
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loader active />;
  } else if (error) {
    throw error;
  }

  return (
    <Grid columns="equal">
      <Grid.Row>
        <Grid.Column textAlign="center">
          <Header as="h1">Welcome to Know My Day Pro!</Header>
          <p>As a reminder, here's what you get with your Pro subscription:</p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Card.Group centered>
            <Card raised color="teal">
              <Card.Content textAlign="center">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Header style={{ margin: 0 }} floated="left">
                    Professional
                  </Header>
                  <Label
                    style={{ marginLeft: "0.5em" }}
                    size="mini"
                    color="blue"
                  >
                    PRO
                  </Label>
                </div>
              </Card.Content>
              <Card.Content>
                <ul>
                  <li>Unlimited students</li>
                  <li>Unlimited Support Staff</li>
                  <li>Report File and Link Attachments</li>
                  <li>Text notifications to Parents</li>
                  <li>Report comments</li>
                  <li>Class-wide announcements</li>
                  <li>Report and comment translation</li>
                  <li>Print range of reports</li>
                </ul>
              </Card.Content>
              <Card.Content textAlign="center">
                You can manage your subscription in your{" "}
                <Link to="/settings#account">Subscription settings</Link>.
              </Card.Content>
            </Card>
          </Card.Group>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row textAlign="center">
        <Grid.Column textAlign="center">
          <Link to="/">Go to your class page</Link>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default PostUpgradePage;
